import {
  Directive,
  HostBinding,
  HostListener,
  computed,
  input,
} from '@angular/core';
import { LoadingDirective } from './loading.directive';

@Directive({
  selector: 'button[nttIconButton], a[nttIconButton]',
})
export class NttIconButton extends LoadingDirective {
  protected override _shouldAddDots = false;

  theme = input<
    | 'solid'
    | 'outline'
    | 'ghost'
    | 'error-solid'
    | 'error-outline'
    | 'error-ghost'
    | 'social'
  >('solid');
  size = input<'sm' | 'md' | 'lg' | 'xl'>('md');
  disabled = input(false);

  hostClasses = computed(() =>
    [
      'ntt-button',
      'ntt-icon-button',
      `ntt-icon-button--${this.theme()}`,
      `ntt-icon-button--${this.size()}`,
      this.disabled() ? 'ntt-button--disabled' : '',
      this.loading() ? 'ntt-icon-button-loading' : '',
      this.loading()
        ? `ntt-icon-button-loading--${this.loadingPosition()}`
        : '',
    ]
      .filter(Boolean)
      .join(' '),
  );

  @HostBinding('disabled') get _disabledAttr() {
    return this._isButton ? this.disabled() : undefined;
  }

  @HostBinding('attr.aria-disabled') get _ariaDisabled() {
    return this.disabled() ? 'true' : undefined;
  }

  @HostBinding('attr.role') get _role() {
    return this._isLink ? 'button' : undefined;
  }

  @HostBinding('attr.tabindex') get _tabindex() {
    return this._isLink && this.disabled() ? '-1' : undefined;
  }

  @HostBinding('class') get hostClassesValue() {
    return this.hostClasses();
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    this._elementRef.nativeElement.focus();
    if (this.loading() || this.disabled()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  protected override _hideChildren() {
    const children = this._elementRef.nativeElement.children;
    for (const child of children) {
      this._renderer.setStyle(child, 'display', 'none');
    }
  }

  protected override _showChildren() {
    const children = this._elementRef.nativeElement.children;
    for (const child of children) {
      this._renderer.removeStyle(child, 'display');
    }
  }

  private get _isButton(): boolean {
    return this._elementRef.nativeElement.tagName === 'BUTTON';
  }

  private get _isLink(): boolean {
    return this._elementRef.nativeElement.tagName === 'A';
  }
}
